export default __webpack_public_path__ + "static/informEmployeesImage-5ba53b91d7b5778c23c0dab76673be66.png";